<script>
	import { onMount } from 'svelte';
	import { Styles, Card,CardBody,
    CardFooter,
    CardHeader,
    CardSubtitle,
    CardText,
    CardTitle } from 'sveltestrap';
	import { api_url, errorColor } from "../ConfigService.js";
	import Loading from "../components/Loading.svelte";
	import { Button, Textfield } from 'svelte-mui/src';

	export let code="";
	//code="noESXaPWwU";
	export let data;
	export let error;

	async function login() {
		const res = await fetch($api_url+'', {
			method: 'POST',
			body: JSON.stringify({
        code: code
			})
		})
    data = await res.json();
		if(await data && !await data.title) { error="Špatně zadaný přístupový kód!"; }
	}

	const handleSubmit = () => {
		login();
	}

	onMount(async () => {
		let url = window.location.href.split("/");
		if(url[3]=="key" && url[4] && url[4]!="") {
			 code=url[4];
			 login();
		}
	});
</script>
{#await data}
	<Loading />
{:then data}
<Card style="width:90%;margin:auto;">
		<CardHeader>
    	<CardTitle>
				{#if !data.title}
					<span style="color:{$errorColor}">Špatně zadaný přístupový kód!</span>
				{:else}
					{data.title}
				{/if}
			</CardTitle>
  	</CardHeader>
		<CardBody>
			{#if data.text && data.text.length>0}
				{#if data.text[0].data.text}
					<CardText>{@html data.text[0].data.text}</CardText>
				{/if}
			{/if}
			<br>
			<Card body style="max-width:350px;margin:auto;" color="light">
				<form on:submit|preventDefault={handleSubmit}>
					<Textfield type="text" label="Zadejte přístupový kód" name="code" bind:value={code} bind:error required class="codeInput" />
					<Button outlined on:click={login}>Vstoupit</Button>
				</form>
			</Card>
	 </CardBody>
	<br>
	<CardFooter style="text-align:right;"><a href="https://www.jahnet.eu" target="jahnet">Tvorba internetových aplikací Jan Holomek</a></CardFooter>
</Card>
{/await}

<style>

</style>
